
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoaderDemoComponent } from './features/loader-demo/loader-demo.component';
import { authGuard } from './guards/auth.guard';
import { OSApprovalComponent } from './os-approval/os-approval.component';

export const routes: Routes = [
    { path: '', component: LoginComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'home', component: HomeComponent, canActivate: [authGuard] },
    { path: 'os-approval', component: OSApprovalComponent, canActivate: [authGuard] },
    {
        path: 'new-os',
        loadComponent: () => import('./features/new-os/new-os').then(m => m.NewOsComponent),
        canActivate: [authGuard]
    },
    {
        path: 'os-detail/:id',
        loadComponent: () => import('./features/os-detail/os-detail').then(m => m.OsDetailComponent),
        canActivate: [authGuard]
    },
    { path: 'loader-demo', component: LoaderDemoComponent }
];
